import React from 'react';

import { InfoField } from '@occc-app/design-system';
import { AwardExternalPointsFragment } from '@occc/graphql';

interface IExternalPointsProps {
  award: AwardExternalPointsFragment;
}

export const ExternalPoints: React.FC<IExternalPointsProps> = ({ award }) => {
  return <InfoField label='Maximum awardable points' value={award?.maximum} />;
};
